// Pharmascience — sticky header scroll-state toggle.
//
// Adds `has-scrolled` to <body> once the user scrolls past the header height.
// Uses a single passive listener with rAF throttling.
//
// 🔴 THE CLASS CURRENTLY HAS NO CSS. Corrected 2026-08-15 (flag F-43); this
// comment previously read "CSS in _components.scss uses this to fade in the
// shadow + frosted backdrop", which was TRUE until Phase 1 and is not now —
// the fourth comment-as-evidence instance found in one day.
//
// What actually happened, from the history rather than from memory: the rule
// DID exist (`body.has-scrolled &` → box-shadow + backdrop-filter, in the
// pre-port _components.scss) and was removed with the sticky header in commit
// 10b2705. That removal was CORRECT porting, not an accident: the design's
// main.css contains ZERO `scrolled` rules and does not make the header sticky
// at all — our built `.bnrmp-site-header` carries no `position:sticky`.
//
// So this module now toggles a class nothing consumes. It is left in place,
// not deleted, because whether the design wants a sticky header is a PHASE 2
// question about the header, and deleting a working scroll listener to
// silence a comment would be the same "make the check green" reflex the flags
// keep catching. Both gates tokenize `bnrmp-*` only, so `is-*`/`has-*` state
// classes are neither harvested nor exempted — also F-43, also Phase 2.
//
// ⏳ RESOLVE IN PHASE 2: either the header becomes sticky and the rule comes
// back, or this module and its listener are deleted.

export function initStickyHeader() {
  const header = document.getElementById('masthead');
  if (!header) return;

  const threshold = 8; // pixels of scroll before the styled state kicks in
  let ticking = false;

  const update = () => {
    document.body.classList.toggle('has-scrolled', window.scrollY > threshold);
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  update();
}
